import FileSearchBoxStore from './schema/FileSearchBoxStore';
import { createStore } from 'satcheljs';
import { MAX_ENTRIES_TYPEDOWN } from '../utils/searchConstants';

export const defaultFileSearchBoxStore: FileSearchBoxStore = {
    suggestion: null,
    maxEntries: MAX_ENTRIES_TYPEDOWN,
    searchBoxWidth: 560,
};

const initialStore = { ...defaultFileSearchBoxStore };
export const getStore = createStore<FileSearchBoxStore>('fileSearchBoxStore', initialStore);

const store = getStore();
export default store;
